
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15","cy":"15","r":"15","fill":"#B4B4B4"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.744 11.257l-10.85 8.034c-.264.205-3.59 1.866-3.934 1.394-.365-.512 2.17-3.074 2.514-3.32l10.85-8.035a.485.485 0 01.69.103l.811 1.127a.497.497 0 01-.101.697h.02z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.089 19.312l11.032-8.158.082.103L9.17 19.414l-.081-.102zM8.034 19.537l12.96-9.572.06.102L8.115 19.64l-.08-.102z","fill":"#DCDCDC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.55 19.414c-.508.307-3.246 1.64-3.53 1.23-.324-.451 1.765-2.583 2.252-2.993l1.277 1.763z","fill":"#DCDCDC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.547 20.685c-.263.062-.466.062-.547-.04-.06-.103-.02-.267.081-.493l.446.533h.02z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.683 11.216l-1.663 1.23c-.081.061-.182.04-.243-.041l-1.116-1.558c-.06-.082-.04-.185.04-.246l1.664-1.23a.425.425 0 01.608.103l.812 1.106a.435.435 0 01-.102.615v.02z","fill":"#DCDCDC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.196 10.109l-1.947 1.435c-.02.02-.06.02-.08-.02l-.548-.78c-.02-.02-.02-.061.02-.082l1.744-1.29a.425.425 0 01.608.102l.264.368c.061.082.04.205-.04.267h-.02z","fill":"#C9C9C9"}})])
          )
        }
      }
    